import { Id } from '../helpers/action/Action.d'

export type EntryId = Id
type ENTRY_TYPE_NORMAL = 42
/** @deprecated legacy entries only */
type ENTRY_TYPE_SEJOUR_PLUS = 39
export const ENTRY_TYPE_SPAN = 40 as const
type ENTRY_TYPE_LEGACY = ENTRY_TYPE_SEJOUR_PLUS | 41 | 43 | 44
type EntryType = typeof ENTRY_TYPE_SPAN | ENTRY_TYPE_NORMAL | ENTRY_TYPE_LEGACY

export type EntryStatus = 'new' | 'processed' | 'modified' | 'deleted'
export type EntrySaveStatus = 'saving' | 'waiting' | 'failed' | 'conflicted' | 'saved' | 'deleting' | 'deleted' | 'refreshing'

export type NotAnEntry = {
    id?: undefined
    date?: undefined
    saveStatus?: undefined
    status?: undefined
    timeout?: undefined
}
export type Entry = {
    id: EntryId
    /** The UUID is currently only used to ensure entry creation idempotency */
    uuid?: string
    date: string
    saveStatus?: EntrySaveStatus
    status?: EntryStatus
    title?: string
    entry?: string
    summary?: string
    type?: EntryType
    loc?: string
    startText?: string
    endText?: string
    rating?: number
    energy?: number
    importance?: number
    price?: string
    matches?: string
    modified?: string
    busyness?: number
    wordcount?: number
    resting_heart_rate?: number
    steps?: number
    sociability?: number
    /** Either a number of milliseconds, or a time in HH:MM:SS format. */
    writeup_time_exact?: number | string

    /** Either a number of milliseconds, or a time in HH:MM:SS format. */
    writeup_time_total?: number | string
}

export type Span = {
    id: EntryId
    title: string
    isSpan: 0 | 1
    spansNow: 0 | 1
    startTimestamp: number
    endTimestamp: number
    immediateChildren: EntryId[]
    numInnerImportant: number
    numInnerSpans: number
    numInnerEntries: number
    collapsed?: boolean
}
